import { render } from "./CustomerCreate.vue?vue&type=template&id=add7cf8c&scoped=true"
import script from "./CustomerCreate.vue?vue&type=script&lang=js"
export * from "./CustomerCreate.vue?vue&type=script&lang=js"

import "./CustomerCreate.vue?vue&type=style&index=0&id=add7cf8c&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-add7cf8c"]])

export default __exports__